// src/components/CopyFromPreviousCard.jsx
// 前の年度の授業から、時間割と授業の設定を写す【2026-11-03】
//   授業スケジュールの画面で、曜日時限がまだ無いときに出す。
//   GET /api/schedule/classes/:id/copy-sources → 候補、POST .../copy-from { sourceClassId, dryRun } → 試しに見てから写す
import React, { useEffect, useState } from 'react';
import { toast } from './Notice';

const DAY = ['日', '月', '火', '水', '木', '金', '土'];
const SETTING_LABEL = { room: '教室', description: '説明', shared_device_mode: '同じ端末の注意', flags_visible_to_students: '学生に印を見せる' };
const auth = () => ({ Authorization: 'Bearer ' + localStorage.getItem('token'), 'Content-Type': 'application/json' });

export default function CopyFromPreviousCard({ classId, onCopied }) {
  const [sources, setSources] = useState(null);
  const [pick, setPick] = useState('');
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch(`/api/schedule/classes/${classId}/copy-sources`, { headers: auth() })
      .then(r => r.json()).then(j => {
        if (!alive || !j.success) return;
        setSources(j.sources || []);
        if (j.suggested) setPick(String(j.suggested.id));
      }).catch(() => {});
    return () => { alive = false; };
  }, [classId]);

  useEffect(() => {
    setPlan(null);
    if (!pick) return;
    let alive = true;
    fetch(`/api/schedule/classes/${classId}/copy-from`, { method: 'POST', headers: auth(), body: JSON.stringify({ sourceClassId: Number(pick), dryRun: true }) })
      .then(r => r.json()).then(j => { if (alive && j.success) setPlan(j.plan); }).catch(() => {});
    return () => { alive = false; };
  }, [classId, pick]);

  if (!sources || sources.length === 0) return null;

  const run = async () => {
    setBusy(true);
    try {
      const r = await fetch(`/api/schedule/classes/${classId}/copy-from`, { method: 'POST', headers: auth(), body: JSON.stringify({ sourceClassId: Number(pick) }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.success) throw new Error(j.message || '写せませんでした');
      toast.success(`時間割 ${j.copiedSchedules}件${j.copiedSettings.length ? '・設定' : ''}を写しました`);
      if (onCopied) onCopied();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  const settingNames = plan ? Object.keys(plan.settings || {}).map(k => SETTING_LABEL[k] || k) : [];
  return (
    <div className="cfp">
      <div className="cfp-head">
        <strong>前の年度の授業から写す</strong>
        <span className="cfp-sub">毎年同じ授業なら、曜日時限・受付・遅刻の線・自動出席・教室をそのまま使えます（学生・出席は写しません）</span>
      </div>
      <div className="cfp-row">
        <select value={pick} onChange={e => setPick(e.target.value)} disabled={busy}>
          <option value="">— 写し元の授業を選ぶ —</option>
          {sources.map(s => (
            <option key={s.id} value={s.id}>
              {s.academicYear ? `${s.academicYear}年度 ` : ''}{s.name}（曜日時限 {s.scheduleCount}件）{s.match === 'same' ? ' ★同じ名前' : ''}
            </option>
          ))}
        </select>
        <button type="button" className="btn-primary" disabled={busy || !pick || !plan || plan.schedules.length === 0} onClick={run}>
          {busy ? '写しています…' : 'この授業に写す'}
        </button>
      </div>
      {plan && (
        <div className="cfp-plan">
          {plan.schedules.length > 0
            ? <>写すもの：{plan.schedules.map((s, i) => (
                <span key={i} className="cfp-chip">{DAY[s.day_of_week]} {s.start_time}〜{s.end_time}{s.room ? `（${s.room}）` : ''}</span>
              ))}</>
            : <span style={{ color: '#b45309' }}>この授業には写せる曜日時限がありません</span>}
          {settingNames.length > 0 && <div>設定：{settingNames.join('・')}も写します（この授業で決めてあるものは変えません）</div>}
        </div>
      )}
    </div>
  );
}
